<div class="container-parametros-rlt">
  <form [formGroup]="form">
    <div class="flex-info-title">
      <span id="info-rlt">{{infoRlt}}</span>
      <div class="switch" style="margin-left: -15px">
        <app-selector [textoOpcion1]="''" [textoOpcion2]="'Activado'" [active]="activo?.value" [control]="'estado'" (mostrarSeleccion)="datosConfiguracionAplicacionService.toggleActivado($event, tipoRlt)"></app-selector>
      </div>
    </div>
    <div [ngStyle]="{display: tipoRlt === 'firmados' ? 'none' : 'block'}" style="margin-bottom: 20px;">
      <h6>Configuración del envío</h6>
      <!-- <label for="dosier">Dosier</label>
      <br>
      <input type="text" formControlName="dosier" [attr.disabled]="true"> -->
    </div>
    <div *ngIf="tipoRlt==='noFirmados'" class="dias-retraso">
      <span style="margin-right: 10px;">Días de retraso desde el envío del dosier</span>
      <input type="number" min="0" class="intervalo" formControlName="diasRetraso">
    </div>
    <div [ngClass]="{'deshabilitado': datosConfiguracionAplicacionService.getRltDesactivado(tipoRlt)}" style="margin-top: 20px;">
      <h6>Planificación del envío</h6>
      <div style="margin-bottom: 20px">
        <div style="margin-bottom: 5px;">
          <label for="periodicidad">Frecuencia</label>
        </div>

        <app-drop-down-single-con-id
                              [data]="frecuencia"
                              (elementoSeleccionado)="datosConfiguracionAplicacionService.getFrecuenciaSeleccionada($event, tipoRlt)"
                              [valorPreSeleccionado]="periodicidad.value"
                              [width]="'100px'"
                              [height]="'26px'"
                              ></app-drop-down-single-con-id>
        <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('periodicidad', tipoRlt)">
          {{validacionesFormularioRltService.mensajeErrorPeriodicidad}}
        </span>
      </div>

  <!-- DIARIA -->
        <div *ngIf="periodicidad.value=='Diaria'" class="">
          <div class="flex-items-center">
            <span>Cada&nbsp;</span>
            <input type="number" class="intervalo" min="1" formControlName="cadaDia">
            <span>&nbsp;días a las&nbsp;</span>
            <app-drop-down-horas-minutos [tiempoSeleccionado]="horaEnvio.value"
                                        (tiempoSeleccionadoEmitter)="datosConfiguracionAplicacionService.getSeleccion($event, 'horaEnvio', tipoRlt)">
                                        </app-drop-down-horas-minutos>
            <span>&nbsp;horas</span>
          </div>
          <div>
            <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('cadaDia',tipoRlt)">
              {{validacionesFormularioRltService.mensajeErrorCadaDia}}
            </span>
            <br>
            <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('horaEnvio',tipoRlt)">
              {{validacionesFormularioRltService.mensajeErrorHoraEnvio}}
            </span>
          </div>
        </div>
  <!-- SEMANAL/QUINCENAL -->
        <div *ngIf="periodicidad.value=='Semanal'" >
          <div class="flex-items-center" style="margin-bottom:5px">
            <span>Los&nbsp;</span>
            <app-drop-down-single-con-id [data]="diasSemana"
                                  (elementoSeleccionado)="datosConfiguracionAplicacionService.getSeleccion($event, 'diaEnvio', tipoRlt)"
                                  [valorPreSeleccionado]="diaEnvio.value"
                                  [width]="'100px'"
                                  [height]="'26px'"></app-drop-down-single-con-id>
            <span>&nbsp;a las&nbsp;</span>
            <app-drop-down-horas-minutos    [tiempoSeleccionado]="horaEnvio.value"
                                        (tiempoSeleccionadoEmitter)="datosConfiguracionAplicacionService.getSeleccion($event, 'horaEnvio', tipoRlt)">
                                        </app-drop-down-horas-minutos>
            <span>&nbsp;horas</span>
          </div>
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('diaEnvio',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorDiaEnvio}}
          </span>
          <br>
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('horaEnvio',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorHoraEnvio}}
          </span>
        </div>
        <div *ngIf="periodicidad.value=='Quincenal'" >
          <div class="flex-items-center" style="margin-bottom:5px">
            <span>Los&nbsp;</span>
            <app-drop-down-single-con-id [data]="diasSemana"
                                  (elementoSeleccionado)="datosConfiguracionAplicacionService.getSeleccion($event, 'diaEnvio', tipoRlt)"
                                  [valorPreSeleccionado]="diaEnvio.value"
                                  [width]="'100px'"
                                  [height]="'26px'"></app-drop-down-single-con-id>
            <span>&nbsp;a las&nbsp;</span>
            <app-drop-down-horas-minutos [tiempoSeleccionado]="horaEnvio.value"
                                        (tiempoSeleccionadoEmitter)="datosConfiguracionAplicacionService.getSeleccion($event, 'horaEnvio', tipoRlt)">
                                        </app-drop-down-horas-minutos>
            <span>&nbsp;horas</span>
          </div>
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('diaEnvio',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorDiaEnvio}}
          </span>
          <br>
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('horaEnvio',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorHoraEnvio}}
          </span>
        </div>
  <!-- MENSUAL -->
        <div *ngIf="periodicidad.value=='Mensual'">
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('frecuenciaMensual',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorFrecuenciaMensual}}
          </span>
          <div class="flex-items-center">
            <input type="radio" formControlName="frecuenciaMensual" name="frecuenciaMensual" value="diaDelMes" (click)="datosConfiguracionAplicacionService.habilitarRadio('diaDelMes', tipoRlt)"/>
            <label [ngClass]="{'flex-items-center':true, 'deshabilitado': datosConfiguracionAplicacionService.getRadioDiaMesDeshabilitado(tipoRlt)}">
              <span style="margin-left: 10px">Cada&nbsp;</span>
              <input type="number" min="1" class="intervalo" formControlName="diaMes">
              <span>&nbsp;del mes</span>
            </label>
          </div>
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('diaMes',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorDiaMes}}
          </span>
          <div class="flex-items-center" style="margin-top: 10px;">
            <input type="radio" formControlName="frecuenciaMensual" name="frecuenciaMensual" value="tipoDeDia" (click)="datosConfiguracionAplicacionService.habilitarRadio('tipoDeDia', tipoRlt)"/>
            <label [ngClass]="{'flex-items-center':true, 'deshabilitado': datosConfiguracionAplicacionService.getRadioTipoDiaDeshabilitado(tipoRlt)}">
              <span style="margin-left: 10px">El&nbsp;</span>
              <app-drop-down-single-con-id [data]="['primer', 'último']"
                                    (elementoSeleccionado)="datosConfiguracionAplicacionService.getSeleccion($event, 'primerUltimoDia', tipoRlt)"
                                    [valorPreSeleccionado]="primerUltimoDia.value"
                                    [width]="'100px'"
                                    [height]="'26px'"></app-drop-down-single-con-id>
              <span>&nbsp;</span>
              <app-drop-down-single-con-id [data]="['laborable', 'natural']"
                                    (elementoSeleccionado)="datosConfiguracionAplicacionService.getSeleccion($event, 'tipoDia', tipoRlt)"
                                    [valorPreSeleccionado]="tipoDia.value"
                                    [width]="'100px'"
                                    [height]="'26px'"></app-drop-down-single-con-id><span>&nbsp;del mes</span>
            </label>
          </div>
          <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('tipoDia',tipoRlt)">
            {{validacionesFormularioRltService.mensajeErrorTipoDia}}
          </span>
          <div [ngClass]="{'flex-items-center':true, 'deshabilitado': datosConfiguracionAplicacionService.getRadioHoraDeshabilitado(tipoRlt)}" style="margin-top:30px;">
            <span>a las&nbsp;</span>
            <app-drop-down-horas-minutos [tiempoSeleccionado]="horaEnvio.value"
                                        (tiempoSeleccionadoEmitter)="datosConfiguracionAplicacionService.getSeleccion($event, 'horaEnvio', tipoRlt)">
                                        </app-drop-down-horas-minutos>
            <span>&nbsp;horas</span>
          </div>
            <span class="texto-validacion" *ngIf="validacionesFormularioRltService.isCampoValidoRlt('horaEnvio',tipoRlt)">
              {{validacionesFormularioRltService.mensajeErrorHoraEnvio}}
            </span>
        </div>
  <!-- FIN MENSUAL -->
    </div>
  </form>

</div>
